// extracted by mini-css-extract-plugin
module.exports = {"icon":"ArchivedMarker-icon-5a564242fcdf5275658be0f4ef48e0fc"};